import { array, object, string } from "yup";

export type CompanyStoreMail = {
	email: string;
	id: number;
};

export type MailsCreateParams = {
	companyStoreMails: MailCreateParam[];
};

export type MailCreateParam = {
	email: string;
	key: string;
};

export const validationSchemaCompanyStoreMail = object().shape({
	companyStoreMails: array().of(
		object().shape({
			email: string()
				.email("メールアドレスの形式を確認してください")
				.required("メールアドレスは必須です")
				.nullable()
		})
	)
});
